export const CONTACT = {
  name: "The Mailbox Brothers LLC",
  tagline: "Mailbox, fixture & exterior refinishing",
  phone: "256-975-0530",
  phoneHref: "tel:+12569750530",
  smsHref: "sms:+12569750530",
  email: "Mailbox.brotherz@gmail.com",
  area: "Huntsville & Auburn, AL",
};

export const ABOUT =
  "At The Mailbox Brothers, we believe no job is too small! Our philosophy is simple: we earn your trust at the curb by delivering high-quality craftsmanship, reliability and attention to detail on even the smallest project — so we can show you firsthand why you can call us for all your painting needs!";

export const FLAT_RATE = {
  label: "Flat Rate",
  title: "Mailbox Repainting — $50",
  desc: "All mailbox repaintings — including the post, flag and numbers — are $50.",
  note: "* Upcharges may apply.",
};

export const WHAT_WE_PAINT = [
  "Mailboxes & Posts",
  "Light Posts & Fixtures",
  "Garage Doors",
  "Fences & Railings",
  "Outdoor Furniture",
  "Contact Us With Any Other Requests",
];

export const LOGO_WHITE = "/logo-white.png";
export const LOGO_BLACK = "/logo-black.png";

const A = "https://customer-assets-4nw71qhi.emergentagent.net/job_paint-portfolio-41/artifacts";

// Real before/after work.
export const WORK = [
  {
    title: "Mailbox Restoration",
    desc: "Mildew-covered and faded. Cleaned and painted top to bottom to look like new!",
    before: `${A}/4un4xd4z_72e2b0ef-180f-412d-bf28-597945ecae5d.jfif`,
    after: `${A}/4ghdydor_image%20%282%29.jpg`,
    orientation: "portrait",
  },
  {
    title: "Mailbox & Post Restoration",
    desc: "Chalked-out post and box refinished top to bottom, flag and numbers included.",
    before: `/work_mailbox3233_before.webp`,
    after: `/work_mailbox3233.webp`,
    orientation: "portrait",
  },
  {
    title: "Garage Door Refresh",
    desc: "Dingy, streaked panels washed and repainted to look as good as new.",
    before: `${A}/sz9zw6ju_image%20%281%29.jpg`,
    after: `${A}/34uv1b65_image%20%285%29.jpg`,
    orientation: "landscape",
  },
  {
    title: "Column Light Fixture",
    desc: "An old, weathered light fixture taken apart, sanded and refinished.",
    before: `/work_col_before.webp`,
    after: `/work_col_after.webp`,
    orientation: "portrait",
  },
  {
    title: "Coach Light Refinish",
    desc: "Faded, sun-worn coach light stripped and repainted to a crisp, like-new finish.",
    before: `/work_coach_before.webp`,
    after: `/work_coach_after.webp`,
    orientation: "portrait",
  },
];

export const MARQUEE_ITEMS = [
  "Mailboxes",
  "Light Fixtures",
  "Garage Doors",
  "Fences",
  "Railings",
  "Outdoor Furniture",
  "$50 Flat Rate",
];

export const SERVICE_OPTIONS = [
  "Mailbox & Post",
  "Light Post & Fixture",
  "Garage Door",
  "Fence & Railing",
  "Outdoor Furniture",
  "Other request",
];
